<template>
	<div class="grid-view">
		<a class="grid-item" v-for="(item, index) in items" :key="index" @click="$emit('itemClick', index)" :style="{
        width: widthPercent,
		backgroundColor: selectedIndex === index ? item.bgColorSelected : item.bgColor,
		borderColor : selectedIndex === index ? item.borderColorSelect : item.borderColor,
		marginLeft : index % columns !== 0 ? gap : '0px'
      }">
			<div class="label" :style="{
          color: selectedIndex === index ? item.textColorSelected : item.textColor
        }">
				{{ item.title }}
			</div>
		</a>
	</div>
</template>

<script>
	export default {
		name: 'custom-grid-view',
		props: {
			items: {
				type: Array,
				required: true
			},
			selectedIndex: {
				type: Number,
				default: 0
			},
			columns: {
				type: Number,
				default: 4
			},
			gap: {
				type: String,
				default: '13px'
			}
		},
		computed: {
			widthPercent() {
				const gap = parseInt(this.gap.replace(/px$/, '')) || 0
				const totalGap = gap * (this.columns - 1)
				return `calc((100% - ${totalGap}px) / ${this.columns})`
			}
		}
	}
</script>

<style scoped>
	.grid-view {
		display: flex;
		flex-wrap: wrap;
	}

	.grid-item {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 12px;
		padding: 10px 0;
		border-radius: 10px;
		border-style: solid;
		border-width: 1px;
	}

	.label {
		font-size: 15px;
	}
</style>
